import { render, staticRenderFns } from "./prodottiUpgrade.vue?vue&type=template&id=1557abae&"
import script from "./prodottiUpgrade.vue.ts?vue&type=script&lang=ts&"
export * from "./prodottiUpgrade.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports